/**
 * File navigation.js.
 */
(function () {

    const navigationMenu = document.querySelector('.mobile-menu');
    navigationMenu.addEventListener("click", function() {
        document.querySelector('body').classList.toggle("-mobile-menu");
    });

}());
